import React from 'react';
import PropTypes from 'prop-types';
import ContactsSearch from 'components/Contacts/ContactsSearch';
import Icon from 'components/Utils/NewIcon';

const ContactsSearchModal = ({
  backButton,
  onClose,
  onSelect,
  addScreen,
  contact,
  patient,
  title = 'Select Contact',
}) => {
  return (
    <div className="modal consultant-search-modal fullscreen">
      <div className="title">
        {!!backButton && (
          <div onClick={backButton} className="back-button">
            <Icon src="arrow-left" />
          </div>
        )}
        {!!onClose && (
          <div onClick={onClose} className="back-button">
            <Icon src="xmark" />
          </div>
        )}
        {title}
      </div>
      <div className="content">
        <ContactsSearch
          patient={patient}
          onSelect={onSelect}
          addScreen={addScreen}
          contact={contact}
          fullscreen={true}
        />
      </div>
    </div>
  );
};

ContactsSearchModal.propTypes = {
  backButton: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
  addScreen: PropTypes.bool,
  contact: PropTypes.object,
  patient: PropTypes.object,
  title: PropTypes.string,
};

export default ContactsSearchModal;
